<template>
  <div class="keypal-card">
    <Header security isKeyPalCard />
    <div class="keypal-card-header">
      <div class="keypal-card-header-video">
        <video
          id="video"
          :src="headerVideo"
          autoplay
          loop
          muted
          x5-video-player-fullscreen="true"
          x5-video-player-type="h5"
          playsinline="true"
          webkit-playsinline="true"
        ></video>
        <video
          id="video-mobile"
          :src="headerMobileVideo"
          autoplay
          loop
          muted
          x5-video-player-fullscreen="true"
          x5-video-player-type="h5"
          playsinline="true"
          webkit-playsinline="true"
        ></video>
      </div>
      <div class="keypal-card-header-content">
        <div class="title">KeyPal <span>Card</span></div>
        <div class="title-mobile">
          <p>KeyPal</p>
          <p>Card</p>
        </div>
        <div class="buy-button" @click="goBuyKeyPalCard">
          {{ $t('home.preSale') }}
        </div>
      </div>
    </div>
    <div class="keypal-card-video">
      <div class="keypal-card-video-content">
        <!-- <div class="video-wrap">
          <video src=""></video>
        </div> -->
        <div class="box-list">
          <!-- <div class="line"></div> -->
          <div class="card-box-wrap">
            <CardBox
              v-for="(item, index) in videoBoxList"
              :key="index"
              :boxData="item"
              videoCard
            />
          </div>
          <!-- <div class="line line-bottom"></div> -->
        </div>
        <div class="horizontal-box-wrap">
          <div class="horizontal-box-left">
            <div class="title" v-if="isEn">
              {{ $t('keypalCard.text_2_1') }}
            </div>
            <div class="title" v-else>
              {{ $t('keypalCard.text_2_1_1') }} <br/>
              {{ $t('keypalCard.text_2_1_2') }}
            </div>
            <div class="desc-wrap">
              <div class="desc">
                {{ $t('keypalCard.text_2_2') }}
              </div>
              <div class="desc">
                {{ $t('keypalCard.text_2_3') }}
              </div>
              <div class="desc">
                {{ $t('keypalCard.text_2_4') }}
              </div>
              <div class="desc">
                {{ $t('keypalCard.text_2_5') }}
              </div>
            </div>
          </div>
          <div class="horizontal-box-right">
            <img src="../assets/images/keypal-card/h-box-1.png" alt="" />
          </div>
        </div>
      </div>
    </div>
    <div class="keypal-card-container">
      <div class="keypal-card-content">
        <div class="title" v-if="$i18n.locale === 'zh'">
          <p>简易而不简单，<br />由 <span>TokenPocket</span> 全心推出</p>
        </div>
        <div class="title" v-else-if="$i18n.locale === 'zh-tw'">
          <p>簡易而不簡單，<br />由 <span>TokenPocket</span> 全心推出</p>
        </div>
        <div class="title" v-else>
          <p>
            Simple, <br />
            but not that simple. <br />
            Powered by <span>TokenPocket</span>
          </p>
        </div>
        <div class="tp-img-wrap">
          <img class="tp-img" :src="tpImg" alt="" />
        </div>
        <div class="desc">
          {{ $t('keypalCard.text_3_1') }}
          <span>{{ text1 }}</span>
        </div>
      </div>
      <div class="box-list-2">
        <CardBox
          v-for="(item, index) in boxList2"
          :key="index"
          :boxData="item"
        />
      </div>
      <!-- <div class="horizontal-wrap-2" ref="horizontal-wrap-2">
        <div
          class="title"
          :class="{ chinese: $i18n.locale === 'zh' }"
          v-if="$i18n.locale === 'zh'"
        >
          <p>开启您的 <span class="text-gradient">KeyPal Card</span> 之旅</p>
        </div>
        <div
          class="title"
          :class="{ chinese: $i18n.locale === 'zh-tw' }"
          v-else-if="$i18n.locale === 'zh-tw'"
        >
          <p>開啟您的 <span class="text-gradient">KeyPal Card</span> 之旅</p>
        </div>
        <div class="title" v-else>
          <p>Time to get started with your</p>
          <p class="text-gradient">KeyPal Card</p>
        </div>
        <div class="buy-button" @click="goBuyKeyPalCard">
          {{ $t('home.shopNow') }}
        </div>
        <img class="horizontal-img" :src="horizontalImg" alt="" />
      </div> -->
      <div class="horizontal-wrap-2">
        <img class="horizontal-img" :src="horizontalImg" alt="" />
        <img class="horizontal-img-mobile" :src="horizontalMobileImg" alt="" />
        <div class="text-content">
          <div
            class="title"
            :class="{ chinese: $i18n.locale === 'zh' }"
            v-if="$i18n.locale === 'zh'"
          >
            <div class="text">开启您的</div>
            <div class="text text-gradient">KeyPal Card</div>
            <div class="text">之旅</div>
          </div>
          <div
            class="title"
            :class="{ chinese: $i18n.locale === 'zh-tw' }"
            v-else-if="$i18n.locale === 'zh-tw'"
          >
            <div class="text">開啟您的</div>
            <div class="text text-gradient">KeyPal Card</div>
            <div class="text">之旅</div>
          </div>
          <div class="title" v-else-if="$i18n.locale === 'ja'">
            <div class="text text-gradient">KeyPal Card</div>
            <div class="text">の旅を始めましょう</div>
          </div>
          <div class="title" v-else-if="$i18n.locale === 'ko'">
            <div class="text text-gradient">KeyPal Card</div>
            <div class="text">여정을 시작하세요</div>
          </div>
          <div class="title" v-else-if="$i18n.locale === 'fr'">
            <div class="text">Commencez votre aventure</div>
            <div class="text text-gradient">KeyPal Card</div>
          </div>
          <div class="title" v-else-if="$i18n.locale === 'es'">
            <div class="text">Empieza tu viaje con</div>
            <div class="text text-gradient">KeyPal Card</div>
          </div>
          <div class="title" v-else-if="$i18n.locale === 'en'">
            <div class="text">Time to get started with your</div>
            <div class="text text-gradient">KeyPal Card</div>
          </div>
          <div class="buy-button" @click="goBuyKeyPalCard">
            {{ $t('home.preSale') }}
          </div>
        </div>
      </div>
    </div>
    <div class="keypal-card-advantage">
      <div class="advantage-list">
        <CardBox
          v-for="(item, index) in advantageList"
          :key="index"
          :boxData="item"
        />
      </div>
      <div class="horizontal-box-list"></div>
    </div>
    <Footer />
  </div>
</template>

<script>
import CardBox from '../components/common/CardBox.vue';
import Footer from '../components/common/Footer.vue';
import Header from '../components/common/Header.vue';
// import HorizontalBox from '../components/common/HorizontalBox.vue';
import buyCardLink from '../mixins/buyCardLink';
export default {
  components: { Header, Footer, CardBox },
  data() {
    return {};
  },
  mixins: [buyCardLink],
  computed: {
    isEn() {
      if (this.$i18n.locale === 'en' || this.$i18n.locale === 'fr' || this.$i18n.locale === 'es' || this.$i18n.locale === 'ko' || this.$i18n.locale === 'ja') {
        return true;
      } else {
        return false;
      }
    },
    langImg() {
      let lang = '-en';
      if (this.$i18n.locale === 'zh') {
        lang = '-zh';
      }
      return lang;
    },
    headerVideo() {
      return `https://hk.tpstatic.net/keypal-card/header-video${this.langImg}.mp4?version=1`;
    },
    headerMobileVideo() {
      return `https://hk.tpstatic.net/keypal-card/header-mobile-video${this.langImg}.mp4?version=1`;
    },
    text1() {
      if (this.$i18n.locale === 'zh') {
        return '无缝衔接，简便且安全。';
      } else if (this.$i18n.locale === 'zh-tw') {
        return '無縫銜接，簡單又安全。';
      } else {
        return 'Seamless, easy and safe.';
      }
    },
    tpImg() {
      return require(`../assets/images/keypal-card/tp-keypal-card${this.langImg}.png`);
    },
    horizontalImg() {
      return require(`../assets/images/keypal-card/horizontal-bg${this.langImg}.png`);
    },
    horizontalMobileImg() {
      return require(`../assets/images/keypal-card/h-wrap-2-bg${this.langImg}.png`);
    },
    videoBoxList() {
      return [
        {
          title: this.isEn
            ? this.$t('keypalCard.text_1_1')
            : this.$t('keypalCard.text_1_1_1'),
          title2: this.isEn ? '' : this.$t('keypalCard.text_1_1_2'),
          videoBox: true,
          color2: true,
          img: require(`../assets/images/keypal-card/box-1${this.langImg}.png`),
        },
        {
          title: this.isEn
            ? this.$t('keypalCard.text_1_2')
            : this.$t('keypalCard.text_1_2_1'),
          title2: this.isEn ? '' : this.$t('keypalCard.text_1_2_2'),
          videoBox: true,
          color2: true,
          img: require('../assets/images/keypal-card/box-2.png'),
        },
      ];
    },
    boxList2() {
      return [
        {
          titleImg: require('../assets/images/keypal-card/box-title-3.png'),
          title: this.$t('keypalCard.text_4_5'),
          desc: this.$t('keypalCard.text_4_6'),
          color2: true,
          img: require(`../assets/images/keypal-card/box-8.png`),
        },
        {
          titleImg: require('../assets/images/keypal-card/box-title-1.png'),
          title: this.$t('keypalCard.text_4_1'),
          desc: this.$t('keypalCard.text_4_2'),
          color2: true,
          img: require(`../assets/images/keypal-card/box-3${this.langImg}.png`),
        },
        {
          titleImg: require('../assets/images/keypal-card/box-title-2.png'),
          title: this.isEn
            ? this.$t('keypalCard.text_4_3')
            : this.$t('keypalCard.text_4_3_1'),
          title2: this.isEn ? '' : this.$t('keypalCard.text_4_3_2'),
          desc: this.$t('keypalCard.text_4_4'),
          color2: true,
          img: require('../assets/images/keypal-card/box-4.png'),
        },
      ];
    },
    advantageList() {
      return [
        {
          id: 1,
          title: this.$t('keypalCard.text_6_1'),
          advantage: true,
          color1: true,
          desc: this.$t('keypalCard.text_6_2'),
          img: require('../assets/images/keypal-card/box-5.png'),
        },
        {
          id: 2,
          title: this.$t('keypalCard.text_6_3'),
          color2: true,
          advantage: true,
          desc: this.$t('keypalCard.text_6_4'),
          img: require('../assets/images/keypal-card/box-6.png'),
        },
        {
          id: 3,
          title: this.$t('keypalCard.text_6_5'),
          color1: true,
          advantage: true,
          desc: this.$t('keypalCard.text_6_6'),
          img: require('../assets/images/keypal-card/box-7.png'),
        },
      ];
    },
  },
  mounted() {
    // console.log('framesData', this.framesData);
    this.$nextTick(() => {
      this.initIntersectionObserver();
    });
  },
  methods: {
    initIntersectionObserver() {
      this.intersectionObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entrie) => {
            if (entrie.intersectionRatio >= 0.3) {
              // 可见百分比
              if (entrie.target.className === 'horizontal-wrap-2') {
                this.boardAni = true;
                console.log('进入');
              }
              // 只在挂载的时候执行一次
              // this.intersectionObserver.unobserve(entrie.target)
            } else if (entrie.intersectionRatio === 0) {
              // 完全不可见
              if (entrie.target.className === 'horizontal-wrap-2') {
                this.boardAni = false;
                console.log('离开');
              }
            }
          });
        },
        { threshold: [0, 0.3] }
      );

      if (this.$refs) {
        Object.values(this.$refs).forEach((ele) => {
          this.intersectionObserver.observe(ele);
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@mixin button {
  width: fit-content;
  margin-top: 0.6rem;
  padding: 0.16rem 0.93rem;
  background: #ffffff;
  border-radius: 0.5rem;
  font-size: 0.16rem;
  font-family: 'ExtraBold';
  font-weight: 500;
  color: #101010;
  cursor: pointer;
}
.keypal-card {
  // background: linear-gradient(300deg,#000000 0%, rgba(0,0,0,0.00) 100%);
  .keypal-card-header {
    position: relative;
    width: 100%;
    // height: 8.58rem;
    background: #f4f5f9;
    background: #000000;
    .keypal-card-header-video {
      position: relative;
      width: 100%;
      padding-bottom: 56.25%; /* 16:9 比例 */
      #video {
        position: absolute;
        top: 0;
        left: 0;
        display: block;
        width: 100%;
        height: 100%;
      }
      #video-mobile {
        display: none;
      }
    }
    .keypal-card-header-content {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      // height: 8.58rem;
      // border-radius: 0 0 0.32rem 0.32rem;
      // background: #101010;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .title {
        font-size: 1.12rem;
        font-family: 'ExtraBold';
        text-align: center;
        color: #ffffff;
        span {
          background-image: -webkit-linear-gradient(0deg, #6aff36, #1d92ff 80%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }
      }
      .title-mobile {
        display: none;
      }
      .buy-button {
        @include button();
      }
    }
  }
  .keypal-card-video {
    position: relative;
    background: #f4f5f9;
    padding: 0 0 0.64rem;
    .keypal-card-video-content {
      // max-width: 12rem;
      // margin: 0 auto;
      // width: 100%;
      .video-wrap {
        max-width: 12rem;
        // margin: 0 auto;
        width: 100%;
        position: absolute;
        z-index: 1;
        top: -0.75rem;
        left: 50%;
        transform: translateX(-50%);
        // width: inherit;
        height: 5.68rem;
        background: pink;
        border-radius: 0.42rem;
      }
      .box-list {
        // padding-top: 5.68rem;
        padding-top: 0.68rem;
        .card-box-wrap {
          max-width: 12rem;
          margin: 0 auto;
          display: flex;
          align-items: center;
          justify-content: space-between;
          .card-box {
            width: 48%;
          }
        }
        .line {
          width: 100%;
          border: 0.01rem solid #6f7174;
        }
      }
      .horizontal-box-wrap {
        max-width: 12rem;
        margin: 0 auto;
        margin-top: 0.24rem;
        background: #ffffff;
        border-radius: 0.32rem;
        padding-left: 0.72rem;
        display: flex;
        .horizontal-box-left {
          width: 5.73rem;
          .title {
            margin-top: 1.52rem;
            font-size: 0.52rem;
            color: #181818;
            font-family: 'Bold';
            font-weight: 500;
          }
          .desc-wrap {
            margin-top: 0.4rem;
            margin-bottom: 0.9rem;
            .desc {
              font-size: 0.2rem;
              color: #6f7174;
              line-height: 0.3rem;
            }
          }
        }
        .horizontal-box-right {
          flex: 1;
          margin-left: 0.6rem;
          display: flex;
          align-items: center;
          margin-bottom: 0.1rem;
          img {
            width: 5.15rem;
          }
        }
      }
    }
  }
  .keypal-card-container {
    background: #ffffff;
    padding: 1.5rem 0 0.45rem;
    .keypal-card-content {
      max-width: 14.4rem;
      margin: 0 auto;
      .title {
        max-width: 7rem;
        margin-left: 1.89rem;
        p {
          font-size: 0.56rem;
          font-family: 'Bold';
          font-weight: 500;
          color: #181818;
          line-height: 0.64rem;
        }
        span {
          color: #2980fe;
        }
      }
      .desc {
        // max-width: 8.16rem;
        margin: 1.06rem 0 0 1.89rem;
        margin: 1.06rem 2rem;
        font-size: 0.2rem;
        // font-family: 'Medium';
        font-family: 'Inter-Regular';
        color: #9ea0a5;
        line-height: 0.3rem;
        span {
          color: #2980fe;
        }
      }
      .tp-img-wrap {
        margin-top: 1.28rem;
        display: flex;
        justify-content: flex-end;
        .tp-img {
          width: 10.15rem;
          height: 5.52rem;
        }
      }
    }
    .box-list-2 {
      max-width: 12rem;
      margin: 1.7rem auto 0;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .card-box {
        width: 32%;
        background: #f2f4f7;
        box-shadow: none;
      }
    }
    .horizontal-wrap-2 {
      position: relative;
      max-width: 12rem;
      margin: 0 auto;
      margin-top: 1.68rem;
      height: 7.05rem;
      .text-content {
        position: absolute;
        left: 1.12rem;
        top: 40%;
        transform: translateY(-50%);
        .title {
          position: relative;
          z-index: 1;
          max-width: 4.8rem;
          &.chinese {
            max-width: 3.9rem;
          }
          .text {
            font-size: 0.56rem;
            font-family: 'Bold';
            color: #ffffff;
            font-weight: 500;
          }
          .text-gradient {
            background-image: linear-gradient(91deg, #32d560 0%, #1371ff 90%);
            -webkit-background-clip: text;
            color: transparent;
            font-size: 0.56rem;
            font-family: 'Bold';
            line-height: normal;
          }
        }
        .buy-button {
          @include button();
          position: relative;
          z-index: 1;
          margin-top: 0.4rem;
          padding: 0.2rem 0.8rem;
          font-family: 'SemiBold';
        }
      }
      .horizontal-img {
        position: absolute;
        z-index: 0;
        left: 0;
        top: 0;
        width: 100%;
      }
      .horizontal-img-mobile {
        display: none;
      }
    }
    .horizontal-wrap-2-mobile {
      display: none;
    }
  }
  .keypal-card-advantage {
    padding: 0.24rem 0 1.6rem;
    // background: #fff;
    // background: linear-gradient(180deg,rgba(244,245,249,0.00), #f4f5f9 100%);
    background: linear-gradient(180deg,rgba(255,255,255,1), #f4f5f9 100%);
    .advantage-list {
      max-width: 12rem;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      .card-box {
        width: 30%;
        background: #2980fe;
        padding: 0.64rem 0.3rem;
        &:nth-child(1) {
          background: #2980fe;
        }
        &:nth-child(2) {
          background: #ffffff;
          box-shadow: 0px -56px 80px 0px rgba(54, 65, 80, 0.1);
        }
        &:nth-child(3) {
          background: #33c15b;
        }
      }
    }
  }
}

@media screen and(max-width: 1300px) {
  .keypal-card {
    .keypal-card-header {
    }
    .keypal-card-video {
      .keypal-card-video-content {
        max-width: none;
        width: 100%;
      }
    }
  }
}

@media screen and(max-width: 767px) {
  @mixin button-mobile {
    @include button();
    font-size: 0.25rem;
    padding: 0.27rem 1.1rem;
  }
  .keypal-card {
    .keypal-card-header {
      .keypal-card-header-video {
        #video {
          display: none;
        }
        #video-mobile {
          display: block;
          width: 100%;
          height: auto;
        }
      }
      .keypal-card-header-content {
        border-radius: 0;
        .title {
          display: none;
        }
        .title-mobile {
          display: block;
          p {
            font-size: 1.45rem;
            text-align: center;
            font-family: 'ExtraBold';
            color: #ffffff;
            line-height: 1.52rem;
          }
          :nth-child(2) {
            background-image: -webkit-linear-gradient(
              0deg,
              #6aff36,
              #1d92ff 80%
            );
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
          }
        }
        .buy-button {
          @include button-mobile();
          margin-top: 0.38rem;
        }
      }
    }
    .keypal-card-video {
      .keypal-card-video-content {
        .box-list {
          width: calc(100% - 0.96rem);
          margin: 0 auto;
          .line {
            display: none;
          }
          .card-box-wrap {
            flex-direction: column;
            .card-box {
              width: 100%;
              &:nth-child(n + 2) {
                margin-top: 0.48rem;
              }
            }
          }
        }
        .horizontal-box-wrap {
          max-width: none;
          margin: 0.48rem 0.48rem 0;
          padding: 0 0.48rem;
          flex-direction: column;
          .horizontal-box-left {
            .title {
              margin-top: 0.56rem;
              font-size: 0.53rem;
              font-weight: 700;
            }
            .desc-wrap {
              .desc {
                font-size: 0.28rem;
                line-height: 0.36rem;
              }
            }
          }
          .horizontal-box-right {
            // margin-left: 0;
            img {
              &.box-id2 {
                width: 100%;
              }
            }
          }
        }
      }
    }
    .keypal-card-container {
      padding: 1.5rem 0 0;
      .keypal-card-content {
        .title {
          margin-left: 0;
          max-width: none;
          padding: 0 0.48rem;
          p {
            font-weight: 700;
          }
        }
        .desc {
          margin: 1.8rem 0 0;
          padding: 0 0.48rem;
          font-size: 0.26rem;
          line-height: 0.4rem;
        }
        .tp-img-wrap {
          margin-top: 1.1rem;
          .tp-img {
            width: 100%;
            height: auto;
          }
        }
      }
      .box-list-2 {
        flex-direction: column;
        .card-box {
          width: calc(100% - 0.96rem);
          &:nth-child(n + 2) {
            margin-top: 0.5rem;
          }
        }
      }
      .horizontal-wrap-2 {
        max-width: none;
        height: auto;
        margin-top: 1rem;
        width: calc(100% - 0.96rem);
        .text-content {
          width: max-content;
          left: 50%;
          top: 10%;
          transform: translateX(-50%);
          .title {
            .text {
              text-align: center;
              font-weight: 700
            }
          }
          .buy-button {
            @include button-mobile();
            margin: 0.6rem auto 0;
          }
        }
        .horizontal-img {
          display: none;
        }
        .horizontal-img-mobile {
          display: block;
          width: 100%;
          border-radius: 0.32rem;
        }
      }
    }
    .keypal-card-advantage {
      padding: 1rem 0;
      .advantage-list {
        flex-direction: column;
        width: calc(100% - 0.96rem);
        .card-box {
          width: auto;
          padding: 0.96rem 0.57rem;
          &:nth-child(n + 2) {
            margin-top: 0.4rem;
          }
        }
      }
    }
  }
}
</style>
